// AEM系统需要插入dom节点，SYS(system)标识用于区分前端自由类名
export const __SYS_CMP_CONTAINER__ = 'sys-cmp-container'; // 每个层级最外层都有一个sys-cmp-container，可通过此class获取到每个层级下的组件
export const __SYS_COMMON_FIELD__ = 'sys-common-field'; 
export const __SYS_COMMON_PANEL__ = 'sys-common-panel'; 

// form v3 class
export const __CLASS_FORM_V3__ = 'form-v3'; // dynamic form v3 class
export const __CLASS_FORM_PANEL__ = 'form-panel'; // dynamic form v3 panel class
export const __CLASS_FORM_PANEL_GROUP__ = 'form-panel__group'; // dynamic form v3 panel group class
export const __CLASS_FORM_PANEL_TITLE__ = 'form-panel__title';// dynamic form v3 panel title class

// csr cmp class
export const __CLASS_CSR_CMP__ = 'csr-cmp'; // client side rendering component class

// form item class
export const __CLASS_FORM_ITEM__ = "form-item";

